"use client"

import { useEffect, useState } from "react"
import { Cookie } from "lucide-react"

import { Button } from "@/components/ui/button"
import { LINKS } from "./links"

const STORAGE_KEY = "canalcnh:cookie-consent"

// Banner de consentimento de cookies — LGPD (Lei nº 13.709/2018).
// Registra a escolha do titular (aceitar/recusar) e só some depois de decidir.
export function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Lê a escolha já persistida (fonte externa) no mount — não pode rodar no SSR.
    let show = true
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored === "accepted" || stored === "rejected") show = false
    } catch {
      // localStorage indisponível (modo privado/bloqueado): mostra o aviso mesmo assim.
    }
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setVisible(show)
  }, [])

  function decide(choice: "accepted" | "rejected") {
    try {
      localStorage.setItem(STORAGE_KEY, choice)
      localStorage.setItem(`${STORAGE_KEY}:at`, new Date().toISOString())
    } catch {
      // Sem persistência disponível — apenas oculta o banner nesta sessão.
    }
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      className="fixed inset-x-0 bottom-0 z-50 p-3 sm:p-4"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl bg-card p-5 shadow-[0_24px_60px_-28px_rgba(22,22,26,.45)] ring-1 ring-foreground/10 sm:flex-row sm:items-center sm:gap-6 sm:p-6">
        <div className="flex items-start gap-3.5">
          <span className="hidden size-11 flex-none items-center justify-center rounded-xl bg-primary/10 text-primary sm:flex">
            <Cookie className="size-5.5" />
          </span>
          <p className="text-[13.5px] leading-relaxed text-muted-foreground">
            Usamos cookies para manter você conectado, lembrar suas preferências e entender como a plataforma
            é usada, melhorando sua experiência. Você pode aceitar todos ou usar apenas os essenciais. Saiba
            mais na nossa{" "}
            <a
              href={LINKS.privacy}
              className="font-medium text-primary underline underline-offset-2 hover:opacity-80"
            >
              Política de Privacidade
            </a>
            .
          </p>
        </div>
        <div className="flex flex-none gap-2.5 sm:flex-col md:flex-row">
          <Button
            variant="outline"
            className="h-10 flex-1 rounded-4xl px-4 sm:flex-none"
            onClick={() => decide("rejected")}
          >
            Só essenciais
          </Button>
          <Button
            className="h-10 flex-1 rounded-4xl px-5 sm:flex-none"
            onClick={() => decide("accepted")}
          >
            Aceitar todos
          </Button>
        </div>
      </div>
    </div>
  )
}
